var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSellers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_786_19018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.16 24.027a1 1 0 1 0 2 0h-2Zm4.12-7.835-.395-.918-.028.011-.026.013.449.894Zm2.6-1.318.514.857-.514-.857Zm7.168.137.516-.856-.516.856Zm4.465 5.152a1 1 0 1 0 1.938-.496l-1.938.496ZM5.16 24.027c0-1.057.004-2.501.358-3.862.35-1.35 1.006-2.474 2.21-3.08l-.897-1.787c-1.915.962-2.82 2.71-3.25 4.364-.426 1.643-.421 3.332-.421 4.365h2Zm2.515-6.917a24.758 24.758 0 0 0 2.72-1.379l-1.03-1.715c-.837.503-1.846.984-2.48 1.258l.79 1.836Zm2.72-1.379c.392-.235.777-.49 1.1-.75.296-.238.644-.562.84-.955l-1.79-.891c.006-.013-.054.087-.305.289-.224.18-.524.382-.874.592l1.028 1.715Zm9.814-.433c-.546-.274-1.142-.51-1.626-.703-.533-.211-.862-.345-1.02-.44l-1.031 1.713c.335.202.862.407 1.313.586.498.198 1.012.403 1.466.632l.898-1.788Zm-2.645-1.143c-.766-.462-.843-.617-.826-.588.007.011.01.02.008.012a1.124 1.124 0 0 1-.014-.036l-.033-.083a1.732 1.732 0 0 0-.39-.585l-1.418 1.41c.003.004-.008-.007-.023-.03-.015-.024-.022-.042-.02-.037l.014.036.034.087c.031.076.075.17.14.277.255.41.704.773 1.496 1.25l1.032-1.713Zm5.887 5.512c-.437-1.703-1.347-3.417-3.242-4.369l-.898 1.788c1.191.598 1.847 1.693 2.202 3.077l1.938-.496Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32 8.334a4.2 4.2 0 0 1 8.4 0v1.091a4.2 4.2 0 0 1-8.4 0V8.334Z",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.747 9.924c-.64 1.647-4.483 2.09-6.147 0 1.56-.696 3.434-2.095 4.68-5.223 1.04-2.612 3.653-3.134 4.16-3.134.507 0 2.187.616 1.147 2.183",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4 4.7c1.04 1.394 3.952 3.762 7.28 2.09",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32 21.415h10.4m0 0-3.033-2.611m3.033 2.611-3.033 2.612",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_786_19018"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24.96v24H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSellers);
export default __webpack_public_path__ + "static/media/icon-sellers.4f2dc8fc264ec75f1ab1e06dd6988ebe.svg";
export { ForwardRef as ReactComponent };